import { Injectable } from '@angular/core';

import { filter, map } from 'rxjs';

import { CamBaseService, GraphEndpoint, HandleComplexRequest, HandleSimpleRequest } from '@camelot/server';
import { isNonNullable } from '@camelot/utils';

import { colorSetProps } from './dto/color-set';
import { NoteType, NoteTypeCreationPayloadInput, NoteTypeModifierPayloadInput, noteTypeProps } from './dto/note-type';
import { CREATE_NOTE_TYPE, UPDATE_NOTE_TYPE } from './mutations';
import { GET_NOTE_TYPES } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'planningService',
  endpoint: 'planning',
};

@Injectable({
  providedIn: 'root',
})
export class CamNoteTypesService extends CamBaseService {
  protected _graphEndpoint = graphEndpoint;
  public noteTypes = new HandleSimpleRequest<NoteType[]>();
  public noteType = new HandleComplexRequest<NoteType>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchNoteTypes$() {
    return this.noteTypes.fetch(
      this._graphService
        .fetchPagedQueryList<NoteType>(
          GET_NOTE_TYPES(
            '',
            `
            ${noteTypeProps.get('id')}
            ${noteTypeProps.get('denomination')}
            ${noteTypeProps.get('isActive')}
            ${noteTypeProps.get('colorSetId')}
            ${noteTypeProps.get('colorSet')} {
              ${colorSetProps.get('id')}
              ${colorSetProps.get('backgroundColor')}
              ${colorSetProps.get('borderColor')}
              ${colorSetProps.get('textColor')}
            }
          `,
            `order: { isActive: DESC }`
          ),
          'noteTypes',
          graphEndpoint.clientName
        )
        .pipe(
          filter(isNonNullable),
          map(data => data.items)
        )
    );
  }

  public fetchNoteType$(id: string) {
    return this.noteType.fetch(
      id,
      this._graphService
        .fetchPagedQueryList<NoteType>(
          GET_NOTE_TYPES(
            `where: { id: { eq: "${id}" } }`,
            `
            ${noteTypeProps.get('id')}
            ${noteTypeProps.get('denomination')}
            ${noteTypeProps.get('isActive')}
            ${noteTypeProps.get('colorSetId')}
            ${noteTypeProps.get('colorSet')} {
              ${colorSetProps.get('id')}
              ${colorSetProps.get('backgroundColor')}
              ${colorSetProps.get('borderColor')}
              ${colorSetProps.get('textColor')}
            }
          `,
            `order: { isActive: DESC }`
          ),
          'noteType',
          graphEndpoint.clientName
        )
        .pipe(
          map(data => (data.items && data.items.length === 1 ? data.items[0] : null)),
          filter(isNonNullable)
        )
    );
  }

  public createNoteType$(noteType: NoteTypeCreationPayloadInput) {
    return this._graphService.mutateBuilder<NoteType>(CREATE_NOTE_TYPE(noteType), graphEndpoint.clientName, [
      'noteTypes',
    ]);
  }
  public updateNoteType$(noteType: Partial<NoteTypeModifierPayloadInput>) {
    return this._graphService.mutateBuilder<NoteType>(UPDATE_NOTE_TYPE(noteType), graphEndpoint.clientName, [
      'noteTypes',
    ]);
  }
}
